import { useEffect } from 'react'
import useScroll from 'js/hooks/useScroll'
import { trackScrollDepth } from 'js/analytics/tracking/trackScrollDepth'

export const TrackScrollDepth = () => {
  const { y: yScroll } = useScroll()

  useEffect(() => {
    trackScrollDepth(
      (yScroll / (document.body.clientHeight - window.innerHeight)) * 100,
    )
  }, [yScroll])

  return null
}
